
import {
  alternatives,
  criterions,
  stakeholders,
  getAimsBy,
  state,
  getAllItems,
  filterByPropValue,
  getCriterionName,
  getAlternativeName,
  getItemsByPropValue,
  getItemsBy,
  groupItemsByProp,
  getRangeBetween,
  getRangeColorClass,
  showOverlay,
  hideOverlay,
  getWeightedAcceptability,
} from "@/store";
import { CHART_VIEW_NAMES } from "@/store/routes";
import {
  defineComponent,
  ref,
  computed,
  Ref,
  nextTick,
  provide,
  reactive,
  watch,
} from "vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import TableChartOne from "@/components/TableChart/TableChartOne.vue";
import TableChartTwo from "@/components/TableChart/TableChartTwo.vue";
import TableChartThree from "@/components/TableChart/TableChartThree.vue";
import PieChart from "@/components/PieChart.vue";
import { useRouter, useRoute } from "vue-router/composables";
import { orderBy } from "lodash";

export default defineComponent({
  components: {
    HeaderMenu,
    TableChartOne,
    TableChartTwo,
    TableChartThree,
    PieChart,
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const height = ref(null);
    console.log(route.hash, "hash");
    const submenu = ref(
      route.hash
        ? route.hash.replace("#", "")
        : CHART_VIEW_NAMES.ARGUMENTS_COUNT
    );

    watch(submenu, () => {
      if (submenu.value) {
        router.push({ ...route, hash: `#${submenu.value}` });
      }
    });

    const selectedAlternative = ref<number>(1);
    const selectedType: Ref<"criterion" | "stakeholder"> = ref("criterion");
    const selectedCriterion = ref<number>(null);
    const selectedStakeholder = ref<number>(null);
    const selectedAim = ref<number>(null);

    const filteredAims = computed(() => {
      const criterionId = selectedCriterion.value;
      const aims = getAimsBy("criterion", criterionId);
      return Object.values(aims);
    });

    const aimSelectItems = computed(() => {
      if (selectedCriterion.value !== null) {
        // const criterionId = selectedCriterion.value;
        // const aims = getAimsBy("criterion", criterionId);
        return filteredAims.value.map(({ id, name }) => ({
          text: name,
          value: id,
        }));
      } else {
        return null;
      }
    });

    const alternativeSelectItems = computed(() =>
      alternatives.value.map(({ id, name, icon }) => ({
        text: name,
        value: id,
        icon,
      }))
    );

    const typeSelectItems = [
      {
        text: "Criteria",
        value: "criterion",
      },
      {
        text: "Stakeholders",
        value: "stakeholder",
      },
    ];

    const criterionSelectItems = computed(() =>
      criterions.value.map(({ id, name }) => ({
        text: name,
        value: id,
      }))
    );

    const items = computed(() => {
      let filteredItems = getAllItems();
      filteredItems = filterByPropValue(
        filteredItems,
        "alternative",
        selectedAlternative.value
      );
      filteredItems = filterByPropValue(
        filteredItems,
        "criterion",
        selectedCriterion.value!
      );

      return filteredItems;
    });

    const pageSize = ref("auto");

    const printStyle = computed(
      () => `
    @media print {
        @page {
          size: ${pageSize.value} !important;
        }
      }
    `
    );

    const handleExport = () => {
      showOverlay();
      const element: HTMLElement | null = document.querySelector("#to-export");
      element!.style.width = "29.7cm";
      const thElement: HTMLElement | null =
        document.querySelector(".th-vertical");

      const { width, height } = element!.getBoundingClientRect();

      const a4w = 21;
      const a4h = 29.7;

      const pixelToCm = 0.0264583333;
      const ppi = 96;

      const ratio = a4w / width;

      const cmWidth = Number((width * pixelToCm).toFixed(2));
      const cmHeight = Number((height * pixelToCm).toFixed(2));

      // pageSize.value = `${a4w.toFixed(2)}cm ${(height * ratio).toFixed(2)}cm`;
      pageSize.value = `${cmWidth}cm ${cmHeight * 1.001}cm`;

      nextTick(() => {
        window.print();
        element!.style.width = "";
        hideOverlay();
      });
    };

    function hashCode(str: string) {
      // java String#hashCode
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    }

    function intToRGB(i: number) {
      var c = (i & 0x00ffffff).toString(16).toUpperCase();

      return "00000".substring(0, 6 - c.length) + c;
    }

    const sections = computed(() => {
      const totalItems = getItemsBy({
        alternative: selectedAlternative.value,
      });
      const totalItemsLength = totalItems.length;

      if (selectedType.value === "criterion") {
        return criterions.value.map((criterion) => {
          const items = getItemsBy({
            criterion: criterion.id,
            alternative: selectedAlternative.value,
          });

          const itemsLength = items.length;

          const color = `#${intToRGB(hashCode(criterion.name))}`;
          console.log(color);
          return {
            label: criterion.name,
            value: (itemsLength / totalItemsLength) * 100,
            length: itemsLength,
            color: color,
          };
        });
      }

      if (selectedType.value === "stakeholder") {
        return stakeholders.value.map((stakeholder) => {
          const items = getItemsBy({
            stakeholder: stakeholder.id,
            alternative: selectedAlternative.value,
          });

          const itemsLength = items.length;

          const color = `#${intToRGB(hashCode(stakeholder.name))}`;
          console.log(color);
          return {
            label: stakeholder.name,
            value: (itemsLength / totalItemsLength) * 100,
            length: itemsLength,
            color: color,
          };
        });
      }

      return null;
    });

    const sortedSections = computed(() => {
      return orderBy(sections.value, ({ value }) => value || "", ["desc"]);
    });

    // const sections = [
    //   { label: "Red section", value: 25, color: "red" },
    //   { label: "Green section", value: 25, color: "green" },
    //   { label: "Blue section", value: 25, color: "blue" },
    // ];

    return {
      state,
      sortedSections,
      selectedAlternative,
      selectedType,
      selectedCriterion,
      selectedAim,
      selectedStakeholder,
      alternativeSelectItems,
      typeSelectItems,
      criterionSelectItems,
      aimSelectItems,
      filteredAims,
      criterions,
      CHART_VIEW_NAMES,
      getCriterionName,
      getAlternativeName,
      items,
      reactive,
      getRangeBetween,
      getItemsBy,
      getRangeColorClass,
      submenu,
      handleExport,
      printStyle,
      setHeight: () => {
        const tableFilters = document.querySelector("[table-filters]");

        if (tableFilters) {
          const tableFiltersRect = tableFilters.getBoundingClientRect();
          height.value = window.innerHeight - tableFiltersRect.bottom - 24;
        }
      },
    };
  },

  // data: () => ({
  //   state,
  //   height: ""
  // }),

  // computed: {
  //   alternativesIds
  // },
  mounted() {
    this.$nextTick(this.setHeight);
  },
  updated() {
    this.$nextTick(this.setHeight);
  },
  created() {
    window.addEventListener("resize", this.setHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.setHeight);
  },
  // methods: {

  // },
  // props: ["id"]
});
